import moment from "moment";
import * as actionTypes from "../types";
import { updateObject } from "../helpers/utils";
import { CALENDAR_TYPES } from "../../store/helpers/constantVariables";

const initialState = {
  cars: [],
  clients: [],
  calendarType: CALENDAR_TYPES.MONTH,

  periodStartDate: moment().startOf("month"),
  periodEndDate: moment()
    .startOf("month")
    .add(
      moment()
        .startOf("month")
        .daysInMonth() - 1,
      "days"
    ),
  periodDaysCount: moment()
    .startOf("month")
    .daysInMonth(),
  fethPeriod: 1,

  weekStartDate: moment()
    .startOf("day")
    .subtract(1, "days"),
  weekEndDate: moment().add(7, "days"),
  weekDaysCount: 7,
  fethWeek: 1,

  monthStartDate: moment()
    .startOf("day")
    .subtract(4, "days"),
  monthEndDate: moment().add(27, "days"),
  monthDaysCount: moment()
    .startOf("month")
    .daysInMonth(),
  fethMonth: 1,

  quarterStartDate: moment().startOf("month"),
  quarterEndDate: moment()
    .startOf("month")
    .add(90, "days"),
  quarterDaysCount: 90,
  fethQuarter: 1
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_CAR_RENTAL_LIST: {
      return updateObject(state, { rentList: action.rentList });
    }
    case actionTypes.CLEAR_CAR_RENTAL_LIST: {
      return updateObject(state, { rentList: [] });
    }
    case actionTypes.SET_PERIOD_DATA: {
      return updateObject(state, {
        fethPeriod: Math.random(),
        ...action.value
      });
    }
    case actionTypes.SET_WEEK_DATA: {
      return updateObject(state, {
        fethWeek: Math.random(),
        ...action.value
      });
    }
    case actionTypes.SET_MONTH_DATA: {
      return updateObject(state, {
        fethMonth: Math.random(),
        ...action.value
      });
    }
    case actionTypes.SET_QUARTER_DATA: {
      return updateObject(state, {
        fethQuarter: Math.random(),
        ...action.value
      });
    }
    case actionTypes.UPDATE_START_DATE: {
      return updateObject(state, {
        startDate: moment(action.val)
      });
    }
    case actionTypes.UPDATE_END_DATE: {
      return updateObject(state, { periodEndDate: moment(action.val) });
    }
    case actionTypes.UPDATE_DAYS_COUNT: {
      return updateObject(state, {
        periodDaysCount: action.val,
        calendarType: CALENDAR_TYPES.PERIOD
      });
    }
    case actionTypes.FETCH_CARS: {
      return updateObject(state, { cars: action.cars });
    }
    case actionTypes.SET_RESERVATION: {
      let carsOld = state.cars;
      let carsNew = action.data;
      const id = action.id;

      const index = carsOld.findIndex(a => a.lista_wynajmow.some(c => c.id_wynajem === id));
      carsOld[index] = { ...carsNew[index] }

      return updateObject(state, { cars: [...carsOld] });
    }
    case actionTypes.SET_RENT_DOC: {
      const { rent } = action.value
      const { data_do, data_od, id_wynajem } = rent

      let carsOld = [...state.cars]
      const carIndex = carsOld.findIndex(a => a.lista_wynajmow.some(c => c.id_wynajem === id_wynajem));
      carsOld[carIndex].data_do = data_do;
      carsOld[carIndex].data_od = data_od;

      return updateObject(state, { cars: carsOld });
    }
    case actionTypes.SET_RENT: {
      const { rent, id, samochodId } = action.value
      let carsOld = state.cars;

      if (id) {
        carsOld = [...state.cars]
        const wynajemId = id
        const carIndex = carsOld.findIndex(a => a.lista_wynajmow.some(c => c.id_wynajem === wynajemId));
        const carRentListIndex = carsOld[carIndex].lista_wynajmow.findIndex(a => a.id_wynajem === wynajemId)
        carsOld[carIndex].lista_wynajmow[carRentListIndex] = { ...carsOld[carIndex].lista_wynajmow[carRentListIndex] }
      } else {
        const wynajemId = rent.id_wynajem
        const carIndex = carsOld.findIndex(a => a.lista_wynajmow.some(c => c.id_wynajem === wynajemId));
        const oldCar = carsOld[carIndex];
        const oldCarRentListIndex = oldCar.lista_wynajmow.findIndex(a => a.id_wynajem === wynajemId);

        if (oldCar.id === samochodId) {
          carsOld[carIndex].lista_wynajmow[oldCarRentListIndex] = { ...rent };
        } else {
          carsOld[carIndex].lista_wynajmow.splice(oldCarRentListIndex, 1)
          const newCarIndex = carsOld.findIndex(a => a.id === samochodId)
          carsOld[newCarIndex].lista_wynajmow.push({ ...rent })
        }
      }

      return updateObject(state, { cars: carsOld });
    }
    case actionTypes.REMOVE_RENT: {
      const id = action.id;
      let carsOld = state.cars;
      const index = carsOld.findIndex(a => a.lista_wynajmow.some(c => c.id_wynajem === id));
      carsOld[index].lista_wynajmow = carsOld[index].lista_wynajmow.filter(c => c.id_wynajem != id)

      return updateObject(state, { cars: [...carsOld] });
    }
    case actionTypes.CLEAR_CARS: {
      return updateObject(state, { cars: [] });
    }
    case actionTypes.SET_CALENDAR_TYPE: {
      return updateObject(state, { calendarType: action.calendarType });
    }
    case actionTypes.FETCH_CLIENTS: {
      return updateObject(state, { clients: action.clients });
    }
    case actionTypes.UPDATE_CLIENTS: {
      const clients = [...state.clients];
      const clientIndex = state.clients.findIndex(client => {
        return client.id_klient === action.client.id_klient;
      });

      if (clientIndex != -1) {
        clients[clientIndex] = action.client;
      } else {
        clients.push(action.client);
      }
      return updateObject(state, { clients });
    }
    case actionTypes.DELETE_CLIENT: {
      return {
        ...state,
        clients: state.clients.filter(client => client.id_klient !== action.value)
      }
    }
    default:
      return state;
  }
}
